import React from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Box } from "@material-ui/core";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Tooltip from "@material-ui/core/Tooltip";
import { green } from "@material-ui/core/colors";
import PropTypes from "prop-types";

import { MATERIAL_UI_PROPS } from "../../lib/data";

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: "none",
    },
    paper: {
        padding: theme.spacing(1),
    },
}));

const PeriodPopover = (props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const { numsNode } = createCellNode(props.min_los, props.max_los);
    const popUpContent = `Мин срок проживания ${props.min_los && !isNaN(props.min_los) ? props.min_los : "—"} Макс срок проживания ${props.max_los && !isNaN(props.max_los) ? props.max_los : "—"}`;

    return (
        <Box style={{ minHeight: "40px" }}>
            <Box position="relative">
                <Box
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}
                >
                    {numsNode}
                </Box>
            </Box>
            <Popover
                id="mouse-over-popover"
                transitionDuration={{ enter: 600 }}
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography>{popUpContent}</Typography>
            </Popover>
        </Box>
    );
};

// Helper functions
/**
 * Creates Cell Node
 *
 * @param {Number} outerVacant
 * @param {Number} outerReserved
 * @param {Object} outerResult
 *
 * @return {Object}
 */

const createCellNode = (min_los, max_los) => {
    const numsNode = (
        <>
            <div>{min_los && !isNaN(min_los) ? min_los : "—"}</div>
            <div>{max_los && !isNaN(max_los) ? max_los : "—"}</div>
        </>
    );
    return { numsNode };
};

export default PeriodPopover;
